import FeatureCard from '../components/FeatureCard'

const features = [
  {
    icon: <img src="/imagenes/scout conecta.png" alt="Scout Conecta" style={{ width: '70px' }} />,
    title: "Scout Conecta",
    description: "Aplicación definitiva para el movimiento scout mexicano con gestión integral de scouts, scouters y administradores."
  },
  {
    icon: <img src="/imagenes/ascensos app vortex.png" alt="Ascensos App Vortex" style={{ width: '70px' }} />,
    title: "Ascensos App Vortex",
    description: "Sistema integral de educación con herramientas de IA para estudiar leyendo, escuchando e interactuando."
  },
  {
    icon: <img src="/imagenes/vortex texto a audios.png" alt="Vortex Texto - Audio" style={{ width: '70px' }} />,
    title: "Vortex Texto - Audio",
    description: "Convierte cualquier texto en audio de alta calidad con síntesis de voz avanzada."
  },
  {
    icon: <img src="/imagenes/vortex audio a textos.png" alt="Vortex Audio Texto IA" style={{ width: '70px' }} />,
    title: "Vortex Audio Texto IA",
    description: "Transcribe grabaciones de voz y archivos de audio a texto usando IA avanzada."
  },
  {
    icon: <img src="/imagenes/flashcards.png" alt="Flashcard Vortex" style={{ width: '70px' }} />,
    title: "Flashcard Vortex",
    description: "Revoluciona el estudio con tarjetas inteligentes y aprendizaje conceptual impulsado por IA."
  },
  {
    icon: <img src="/imagenes/ascensos app lite.png" alt="Ascensos App Lite" style={{ width: '70px' }} />,
    title: "Ascensos App Lite",
    description: "Aplicación educativa para preparación de exámenes de ascenso en la Marina de México."
  },
  {
    icon: <img src="/imagenes/cuentos que ensenan.png" alt="Cuentos que enseñan" style={{ width: '70px' }} />,
    title: "Cuentos que enseñan",
    description: "Transforma temas escolares aburridos en aventuras emocionantes con IA."
  },
  {
    icon: "🚀",
    title: "Próximas Apps",
    description: "Estamos trabajando en nuevas aplicaciones innovadoras. ¡Mantente atento!"
  }
]

export default function Features() {
  return (
    <section id="features" className="section">
      <div className="container">
        <div className="text-center mb-2xl">
          <h2>Nuestras Aplicaciones</h2>
          <p style={{ maxWidth: '800px', margin: '0 auto' }}>
            Descubre nuestra suite completa de aplicaciones móviles innovadoras para educación y gestión.
          </p>
        </div>

        <div className="grid grid-3">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>

        <div style={{
          marginTop: 'var(--spacing-3xl)',
          textAlign: 'center'
        }}>
          <h3 style={{ marginBottom: 'var(--spacing-lg)' }}>
            ¿Listo para revolucionar tu forma de aprender?
          </h3>
          <p style={{ marginBottom: 'var(--spacing-xl)' }}>
            Explora nuestras aplicaciones y descubre cómo la tecnología puede potenciar tu educación y crecimiento personal.
          </p>
          <a href="#availability" className="btn btn-primary">
            Explorar aplicaciones
          </a>
        </div>
      </div>
    </section>
  )
} 